module.exports = __webpack_public_path__ + "static/img/loginBack.b2176346.png";